import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM6.255 18.617A8.73 8.73 0 0 0 12 20.766a8.729 8.729 0 0 0 5.743-2.148l-3.122-3.122A4.35 4.35 0 0 1 12 16.37a4.35 4.35 0 0 1-2.622-.875l-3.123 3.122Zm9.24-9.242c.55.73.875 1.64.875 2.625 0 .985-.326 1.892-.876 2.623l3.122 3.122A8.728 8.728 0 0 0 20.766 12a8.729 8.729 0 0 0-2.15-5.746l-3.122 3.121ZM5.381 6.255A8.73 8.73 0 0 0 3.234 12c0 2.198.811 4.206 2.148 5.744l3.122-3.123A4.35 4.35 0 0 1 7.63 12c0-.984.325-1.893.874-2.623L5.382 6.255ZM12 8.865a3.136 3.136 0 1 0 0 6.27 3.136 3.136 0 0 0 0-6.27Zm0-5.63a8.73 8.73 0 0 0-5.745 2.147l3.122 3.122A4.35 4.35 0 0 1 12 7.63c.983 0 1.89.325 2.62.873l3.123-3.122A8.73 8.73 0 0 0 12 3.234Z"
      clip-rule="evenodd"
    />
  </svg>
`;
